import {
    Button,
    Checkbox,
    Col,
    Collapse,
    DatePicker,
    Divider,
    Empty,
    Form,
    message,
    Row,
    Select,
    theme,
    Typography,
} from 'antd'
import React, { useMemo, useRef, useState } from 'react'
import DropDownMultiple from '../../../components/dropDownMultiple'
import {
    ExpandIcon,
    SkillsIcon,
    ToolsIcon,
} from '../../../assets/icons'
import { MASTER_DATA_FIELD } from '../../../constants/masterData'
import {
    changeModel,
    masterDataAddDropDown,
    masterDataDropDownList,
    profileState,
} from '../../profile/profile.slice'
import { useDispatch, useSelector } from 'react-redux'
import { loginState } from '../../login/login.slice'
import dayjs from 'dayjs'

import { formatInstitute } from '../../../utils/commonUtils'
import ApiSelect from '../../../components/api-select/api-select'
import { candidateById, candidateEdit } from '../store/candidate.slice'

const EducationForm = ({ onCancel, currantData, activeTab, candidateId, preEducationData }) => {
    const { useToken } = theme
    const { Text, Title } = Typography
    const { token } = useToken()
    const dispatch = useDispatch()
    const timeoutRef = useRef()
    const sessionTokenRef = useRef()
    const [form] = Form.useForm()
    const [skillsData, setSkillsData] = useState([])
    const [toolsData, setToolsData] = useState([])
    const [checked, setChecked] = useState(false)
    const [suggestions, setSuggestions] = useState([])
    const [searchValue, setSearchValue] = useState('')
    const [page, setPage] = useState(0);
    const [status, setStatus] = useState("loading");
    const {
        formButtonType,
        modelType,
        masterDataDropDown,
        isNext
    } = useSelector(profileState)
    const { userProfile } = useSelector(loginState)



    const initialValues = useMemo(() => {
        if (!currantData) {
            return {
                institute: [],
                degree: '',
                fieldOfStudy: null,
                skills: [],
                location: null,
                grade: '',
                start: null,
                end: null,
                softSkills: [],
                programmingLanguages: [],
                tools: [],
                technicalSkills: [],
                currentStudy: false
            };
        }

        const new_obj_institute = formatInstitute(currantData?.institute, token)
        return {
            institute: currantData?.institute ? [new_obj_institute] : [],
            degree: currantData?.degree ? {
                label: currantData?.degree?.name,
                value: currantData?.degree?._id,
            } : null,
            fieldOfStudy: currantData?.fieldOfStudy ? {
                label: currantData?.fieldOfStudy?.name,
                value: currantData?.fieldOfStudy?._id,
            } : null,
            skills: currantData?.skills?.map((skill) => ({
                label: skill?.name,
                value: skill?._id,
            })) || [],
            location: currantData?.location || null,
            grade: currantData?.grade || '',
            start: currantData?.startDate ? dayjs(currantData.startDate) : null,
            end: currantData?.endDate ? dayjs(currantData.endDate) : null,

            softSkills: currantData?.skills || [],
            programmingLanguages: currantData?.programmingLanguages || [],
            tools: currantData?.tools?.length > 0
                ? currantData?.tools.map((data) => {
                    return {
                        label: data?.name,
                        value: data?._id,
                        logo: data?.logo,
                    }
                })
                : [],
            technicalSkills: currantData?.technicalSkills || [],
            currentStudy: currantData.currentStudy || ""

        }


    }, [currantData])


    useMemo(() => {
        if (currantData) {
            setSkillsData(
                currantData?.skills?.map((skill) => ({
                    label: skill?.name,
                    value: skill?._id,
                })) || []
            )
            setToolsData(
                currantData?.tools?.map((tool) => ({
                    label: tool?.name,
                    value: tool?._id,
                    // logo: tool?.logo,
                })) || []
            )
            if (currantData?.currentStudy) {
                setChecked(currantData?.currentStudy)
            }
        }
    }, [currantData])

    const fetchOptions = async (search = "", pageNumber = 1, model) => {
        setStatus("loading");
        setSearchValue(search);

        try {
            dispatch(changeModel(model))
            const result = await dispatch(
                masterDataDropDownList({
                    search: search,
                    id: model,
                    skip: pageNumber
                })
            ).unwrap(); // ⬅️ Get the actual payload

            const newData = Array.isArray(result?.data) ? result.data : [];


            setPage(pageNumber + 1);
            setStatus(newData.length === 0 ? "noData" : "loaded");
        } catch (error) {
            console.error("Dropdown fetch failed", error);
            setStatus("noData");
        }
    };


    const resetPage = () => {
        setPage(1);
    };

    const formatDatePicker = (value) => {
        return `${dayjs(value).format('DD MMM YY')}`
    }

    async function addMasterData() {
        const result = await dispatch(
            masterDataAddDropDown({
                addData: {
                    type: 'manual',
                    data: {
                        name: searchValue,
                        logo:
                            modelType === 'tools'
                                ? 'https://pms-bucket123.s3.amazonaws.com/Layer_1_1689237094.svg'
                                : modelType === 'institute'
                                    ? 'https://pms-bucket123.s3.amazonaws.com/Group 35301_1689226177.svg'
                                    : '',
                        createdBy: userProfile?._id,
                    },
                },
                model: modelType,
            })
        )
        const data = result?.payload?.data

        if (data) {
            const { success, message: errorMessage } = data
            if (success) {
                dispatch(
                    masterDataDropDownList({
                        search: searchValue,
                        id: modelType,
                    })
                )
            } else {
                if (errorMessage) {
                    message.error(errorMessage)
                } else {
                    message.error('Something went wrong, try again later.')
                }
            }
        }
    }

    // GOOGLE PLACE API INTEGRATION
    const loadSuggestions = async (inputValue) => {
        clearTimeout(timeoutRef.current)

        if (!inputValue || inputValue.trim().length <= 1) {
            setSuggestions([])
            return
        }

        timeoutRef.current = setTimeout(async () => {
            if (!sessionTokenRef.current) {
                sessionTokenRef.current =
                    new window.google.maps.places.AutocompleteSessionToken()
            }

            new window.google.maps.places.AutocompleteService().getPlacePredictions(
                {
                    input: inputValue,
                    sessionToken: sessionTokenRef.current,
                },
                (predictions, status) => {
                    if (
                        status ===
                        window.google.maps.places.PlacesServiceStatus
                            .ZERO_RESULTS
                    ) {
                        setSuggestions([])
                        return
                    }
                    if (
                        status !==
                        window.google.maps.places.PlacesServiceStatus.OK ||
                        !predictions
                    ) {
                        return
                    }
                    let newData =
                        predictions?.length > 0 &&
                        predictions.map((data) => {
                            return {
                                label: data?.description,
                                value: data?.description,
                            }
                        })
                    setSuggestions(newData)
                }
            )
        }, 350)
    }

    // DISABLE START DATE
    const disabledDateStart = (current) => {
        const endDate = form.getFieldValue('end')
        // Disable dates that are after the selected end date or dates that are in the future
        return (
            (endDate && current && current.valueOf() > endDate.valueOf()) ||
            (current && current.valueOf() > Date.now())
        )
    }
    // DISABLE END DATE

    const disabledDateEnd = (current) => {
        const startDate = form.getFieldValue('start')
        // Disable dates that are before the selected start date or dates that are in the past
        return startDate
            ? (current && current.valueOf() < startDate.valueOf()) ||
            (current && current.valueOf() > Date.now())
            : current && current.valueOf() > Date.now()
    }
    // COLLAPSE MENU HEADER
    const CollapseLabel = ({ name, icon, description }) => (
        <Row
            align={'middle'}
            style={{
                columnGap: '20px',
                marginBottom: '18px',
                rowGap: "10px"
            }}
        >
            <Row
                style={{
                    height: '50px',
                    width: '50px',
                    borderRadius: '10px',
                    padding: '12px',
                    backgroundColor: token.colorPalette.baseColor.tertiary,
                }}
                align={'middle'}
                justify={'center'}
            >
                <div
                    style={{
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '30px',
                    }}
                >
                    {icon}
                </div>
            </Row>
            <div>
                <Title
                    style={{
                        // fontSize: token.fontSizeHeading4,
                        fontSize: '18px',
                    }}
                >
                    {name}
                </Title>
                <Text className="sub-title" style={{ fontSize: '15px' }}>
                    {description}
                </Text>
            </div>
        </Row>
    )

    const handleCreateEducation = async (edit) => {
        try {
            const values = await form.validateFields();
            const extractValue = (input) => {
                if (Array.isArray(input)) {
                    return input.map(item => item?.value || item)
                } else if (input && typeof input === 'object') {
                    return input.value || input
                }
                return input
            }
            const newEducationEntry = {
                attachments: values.attachments || null,
                institute: extractValue(values.institute), // ✅ Sanitize this!
                degree: extractValue(values.degree),
                fieldOfStudy: extractValue(values.fieldOfStudy),
                skills: extractValue(values.skills),
                tools: extractValue(values.tools),
                location: values.location || null,
                grade: values.grade || null,
                startDate: values.start?.valueOf() || "",
                endDate: values.end?.valueOf() || "",
                currentStudy: values.currentStudy || false,
                summary: values.summary,
                isCompleted: true
            }

            let payload = {}

            if (edit) {
                // Only send edited entry
                const existingEducation = preEducationData?.education || []
                const filteredEducation = existingEducation.filter(
                    edu => edu._id !== currantData?._id
                );

                payload = {
                    education: [...filteredEducation, newEducationEntry],
                    candidateId: candidateId
                }
            } else {
                // Append new entry to existing education array
                const existingEducation = preEducationData?.education || []
                payload = {
                    education: [...existingEducation, newEducationEntry],
                    candidateId: candidateId
                }
            }

            const { data } = await candidateEdit(activeTab, candidateId, payload)
            if (data?.success) {
                dispatch(candidateById({ id: data?.data?._id, activeTab }))
                onCancel(false)
            }
        } catch (error) {
            console.log("🚀 ~ handleCreateEducation ~ error:", error)
        }
    }

    // COLLAPSE ITEMS
    const getItems = () => [
        {
            key: '1',
            label: (
                <CollapseLabel
                    name={`Add Skills ${skillsData?.length > 0 ? `(${skillsData?.length})` : ''
                        }`}
                    icon={
                        <SkillsIcon
                            color={token.colorPalette.baseColor.white}
                        />
                    }
                    description="Please add the skills suitable to your expertise."
                />
            ),
            children: (
                <>

                    <ApiSelect
                        // label="Search Skills*"
                        name={MASTER_DATA_FIELD.skills}
                        rules={
                            formButtonType !== 'draftButtonLoading'
                                ? [{ required: true, message: 'Please Select Field of skills' }]
                                : []
                        }
                        placeholder="Search a Field of skills"
                        tagRender={() => null}
                        rootClassName={[
                            'p-0-multiSelect',
                            skillsData?.length > 0
                                ? 'p-0-multiselect-setMargin'
                                : '',
                        ]}
                        onClick={() => {
                            resetPage();
                            fetchOptions("", 0, MASTER_DATA_FIELD.skills);
                        }}
                        onSelect={(e, options) => {
                            const trimSkills = options?.key.trimStart()
                            if (trimSkills?.length > 0) {
                                setSkillsData([
                                    ...skillsData,
                                    { label: trimSkills, value: e },
                                ])
                            }
                        }}
                        onDeselect={(e) => {
                            const removeData = [...skillsData]
                            removeData.splice(
                                removeData.findIndex(
                                    (item) => item.label === e
                                ),
                                1
                            )
                            setSkillsData(removeData)
                        }}
                        mode={"multiple"}
                        onSearch={(value) => {
                            resetPage();
                            fetchOptions(value, 0, MASTER_DATA_FIELD.skills);
                        }}
                        onScrollBottom={() => {
                            fetchOptions(searchValue, page, MASTER_DATA_FIELD.skills);
                        }}
                        dropdownRender={(menu, handleScroll) => (
                            <DropDownMultiple
                                handleScroll={handleScroll}
                                menu={menu}
                                searchValue={searchValue}
                                name={
                                    MASTER_DATA_FIELD.skills
                                }
                                addMasterData={() =>
                                    addMasterData()
                                }
                            />
                        )}
                        options={masterDataDropDown?.skills}
                        dropdownStatus={status}
                    />

                </>
            ),
        },
        {
            key: '2',
            label: (
                <CollapseLabel
                    name={`Add Tools ${toolsData?.length > 0 ? `(${toolsData?.length})` : ''
                        }`}
                    icon={
                        <ToolsIcon color={token.colorPalette.baseColor.white} />
                    }
                    description="Please add tools suitable to your hands-on experience."
                />
            ),
            children: (
                <>

                    <ApiSelect
                        // label="Search Skills*"
                        name={MASTER_DATA_FIELD.tools}
                        rules={
                            formButtonType !== 'draftButtonLoading'
                                ? [{ required: true, message: 'Please Select Field of tools' }]
                                : []
                        }
                        placeholder="Search a Field of tools"
                        tagRender={() => null}
                        rootClassName={[
                            'p-0-multiSelect',
                            skillsData?.length > 0
                                ? 'p-0-multiselect-setMargin'
                                : '',
                        ]}
                        onClick={() => {
                            resetPage();
                            fetchOptions("", 0, MASTER_DATA_FIELD.tools);
                        }}
                        onSelect={(e, options) => {
                            const trimSkills = options?.key.trimStart()
                            if (trimSkills?.length > 0) {
                                setToolsData([
                                    ...toolsData,
                                    { label: trimSkills, value: e },
                                ])
                            }
                        }}
                        onDeselect={(e) => {
                            const removeData = [...toolsData]
                            removeData.splice(
                                removeData.findIndex(
                                    (item) => item.label === e
                                ),
                                1
                            )
                            setToolsData(removeData)
                        }}
                        mode={"multiple"}
                        onSearch={(value) => {
                            resetPage();
                            fetchOptions(value, 0, MASTER_DATA_FIELD.tools);
                        }}
                        onScrollBottom={() => {
                            fetchOptions(searchValue, page, MASTER_DATA_FIELD.tools);
                        }}
                        dropdownRender={(menu, handleScroll) => (
                            <DropDownMultiple
                                handleScroll={handleScroll}
                                menu={menu}
                                searchValue={searchValue}
                                name={
                                    MASTER_DATA_FIELD.tools
                                }
                                addMasterData={() =>
                                    addMasterData()
                                }
                            />
                        )}
                        options={masterDataDropDown?.tools}
                        dropdownStatus={status}
                    />

                </>
            ),
        },
    ]

    return (
        <div>
            <div>
                <Form

                    labelCol={{
                        style: {
                            padding: '0 0 3px',
                        },
                    }}
                    layout="vertical"
                    initialValues={initialValues}
                    name="addEducation"
                    requiredMark={true}
                    form={form}
                    style={{
                        marginBottom: '20px',

                    }}
                >
                    <Row
                        style={{
                            rowGap: '20px',
                        }}
                        justify={'space-between'}
                        gutter={16}
                    >
                        <Col span={12}>
                            <ApiSelect
                                label="Institute"
                                name={MASTER_DATA_FIELD.institute}
                                rules={
                                    formButtonType !== 'draftButtonLoading'
                                        ? [{ required: true, message: 'Please Select Field of institute' }]
                                        : []
                                }
                                placeholder="Search a Field of institute"
                                onClick={() => {
                                    resetPage();
                                    fetchOptions("", 0, MASTER_DATA_FIELD.institute);
                                }}
                                onSearch={(value) => {
                                    resetPage();
                                    fetchOptions(value, 0, MASTER_DATA_FIELD.institute);
                                }}
                                onScrollBottom={() => {
                                    fetchOptions(searchValue, page, MASTER_DATA_FIELD.institute);
                                }}
                                dropdownRender={(menu, handleScroll) => (
                                    <DropDownMultiple
                                        handleScroll={handleScroll}
                                        menu={menu}
                                        searchValue={searchValue}
                                        name={
                                            MASTER_DATA_FIELD.institute
                                        }
                                        addMasterData={() =>
                                            addMasterData()
                                        }
                                    />
                                )}
                                options={masterDataDropDown?.institute}
                                dropdownStatus={status}
                                isNext={isNext}
                            />
                        </Col>

                        <Col span={12}>
                            <ApiSelect
                                label="Degree"
                                name={MASTER_DATA_FIELD.degree}
                                rules={
                                    formButtonType !== 'draftButtonLoading'
                                        ? [{ required: true, message: 'Please Select Field of degree' }]
                                        : []
                                }
                                placeholder="Search a Field of degree"
                                onClick={() => {
                                    resetPage();
                                    fetchOptions("", 0, MASTER_DATA_FIELD.degree);
                                }}
                                onSearch={(value) => {
                                    resetPage();
                                    fetchOptions(value, 0, MASTER_DATA_FIELD.degree);
                                }}
                                onScrollBottom={() => {
                                    fetchOptions(searchValue, page, MASTER_DATA_FIELD.degree);
                                }}
                                dropdownRender={(menu, handleScroll) => (
                                    <DropDownMultiple
                                        handleScroll={handleScroll}
                                        menu={menu}
                                        searchValue={searchValue}
                                        name={
                                            MASTER_DATA_FIELD.degree
                                        }
                                        addMasterData={() =>
                                            addMasterData()
                                        }
                                    />
                                )}
                                options={masterDataDropDown?.degree}
                                dropdownStatus={status}
                            />
                        </Col>
                        <Col span={12}>
                            <ApiSelect
                                label="Field of Study"
                                name={MASTER_DATA_FIELD.fieldOfStudy}
                                rules={
                                    formButtonType !== 'draftButtonLoading'
                                        ? [{ required: true, message: 'Please Select Field of Study' }]
                                        : []
                                }
                                placeholder="Search a Field of Study"
                                onClick={() => {
                                    resetPage();
                                    fetchOptions("", 0, MASTER_DATA_FIELD.fieldOfStudy);
                                }}
                                onSearch={(value) => {
                                    resetPage();
                                    fetchOptions(value, 0, MASTER_DATA_FIELD.fieldOfStudy);
                                }}
                                onScrollBottom={() => {
                                    fetchOptions(searchValue, page, MASTER_DATA_FIELD.fieldOfStudy);
                                }}
                                dropdownRender={(menu, handleScroll) => (
                                    <DropDownMultiple
                                        handleScroll={handleScroll}
                                        menu={menu}
                                        searchValue={searchValue}
                                        name={
                                            MASTER_DATA_FIELD.fieldOfStudy
                                        }
                                        addMasterData={() =>
                                            addMasterData()
                                        }
                                    />
                                )}
                                options={masterDataDropDown?.fieldOfStudy}
                                dropdownStatus={status}
                            />
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="Location"
                                name="location"
                                rules={
                                    formButtonType !== 'draftButtonLoading' ? [
                                        {
                                            required: true,
                                            message: 'Please Select Location',
                                        },
                                    ] : []
                                }
                                colon={false}
                            >
                                <Select
                                    placeholder="Search a Location"
                                    allowClear={false}
                                    notFoundContent={
                                        <Empty
                                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                                            description="No Locations Searched"
                                        ></Empty>
                                    }

                                    onSearch={(value) => {
                                        loadSuggestions(value)
                                    }}
                                    showSearch
                                    options={suggestions}
                                    getPopupContainer={(trigger) =>
                                        trigger.parentNode
                                    }
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="Start Date"
                                colon={false}
                                name={'start'}
                                rules={
                                    formButtonType !== 'draftButtonLoading' ? [
                                        {
                                            required: true,
                                            message: 'Please Select Start Date',
                                        },
                                    ] : []
                                }
                            >
                                <DatePicker
                                    allowClear={false}
                                    name="start"
                                    disabledDate={disabledDateStart}
                                    format={formatDatePicker}
                                    // getPopupContainer={(trigger) =>
                                    //     trigger.parentNode
                                    // }
                                    getPopupContainer={() => document.body}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="End Date"
                                colon={false}
                                name={'end'}
                                rules={
                                    formButtonType !== 'draftButtonLoading' &&
                                        !checked ? [
                                        {
                                            required: true,
                                            message: 'Please Select End Date',
                                        },
                                    ] : []
                                }
                            >
                                <DatePicker
                                    allowClear={false}
                                    disabled={checked}
                                    disabledDate={disabledDateEnd}
                                    name="end"
                                    format={formatDatePicker}
                                    // getPopupContainer={(trigger) =>
                                    //     trigger.parentNode
                                    // }
                                    getPopupContainer={() => document.body}
                                />
                            </Form.Item>
                        </Col>
                        <Col>
                            <Form.Item
                                name="currentStudy"
                                valuePropName="checked"
                                rules={
                                    formButtonType !== 'draftButtonLoading' &&
                                        !checked ? [
                                        {
                                            required: false,
                                            message: 'Please Select End Date',
                                        },
                                    ] : []
                                }
                            >
                                <Checkbox
                                    onChange={(e) => {
                                        setChecked(e.target.checked)
                                        if (e.target.checked === true) {
                                            form.setFields([
                                                {
                                                    name: 'end',
                                                    errors: [],
                                                },
                                            ])
                                        }
                                        form.setFieldValue('end', '')
                                    }}
                                    checked={checked}

                                >
                                    I currently study here
                                </Checkbox>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Divider />
                    <Collapse
                        bordered={false}
                        defaultActiveKey={['1', '2']}
                        expandIcon={({ isActive }) => {
                            return <ExpandIcon isActive={!isActive} />
                        }}
                        expandIconPosition="right"
                        style={{
                            backgroundColor: 'transparent',
                        }}
                        items={getItems()}
                    />
                    <Divider style={{ marginTop: '0px' }} />
                    <div
                        style={{
                            marginTop: '15px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'end',
                        }}
                    >
                        <Button
                            variant="outlined"
                            style={{ marginRight: "10px", color: "#000", backgroundColor: "transparent", border: "1px solid #d9d9d9" }}
                            color="default"
                            onClick={() => onCancel(false)}

                        >
                            Cancel
                        </Button>
                        <Button style={{ marginLeft: '12px' }} onClick={() => currantData ? handleCreateEducation("edit") : handleCreateEducation()}>{currantData ? "Save Change" : " Add"}</Button>
                    </div>
                </Form>
            </div>
        </div>
    )
}

export default EducationForm
